import {
  Component,
  Input,
  Output,
  EventEmitter,
  SimpleChanges,
} from "@angular/core";
import { faCaretRight, faCaretDown } from "@fortawesome/pro-solid-svg-icons";
import { CustomSkeletonConfig } from "src/app/shared/custom-skeleton/custom-skeleton-model";
import {
  EntityGroup,
  OtherSelectedDetails,
} from "src/app/store/models/industry-page.model";

@Component({
  selector: "app-geography-filter",
  templateUrl: "./geography-filter.component.html",
  styleUrls: ["./geography-filter.component.scss"],
})
export class GeographyFilterComponent {
  @Input() geographyData;
  @Input() otherGeoLen: number;
  @Output() geographySelect: EventEmitter<any> = new EventEmitter();
  @Input() popularGeography: EntityGroup;
  @Input() otherGeographies: Array<EntityGroup>;
  @Input() popularSelected: Set<number> = new Set();
  @Input() otherSelected: OtherSelectedDetails;
  @Input() allGeography;
  @Input() isLoading: boolean;

  skeletonDefaultConfig: CustomSkeletonConfig = {
    skeletonType: "list",
    config: {
      list: {
        noOfListItems: 24,
      },
    },
  };
  otherSelectedArray = [];
  isPopularExpanded = true;
  otherGeoExpandedKeys = [];
  faCaretRight = faCaretRight;
  faCaretDown = faCaretDown;
  constructor() {}

  ngOnChanges(changes: SimpleChanges) {
    if (
      changes.geographyData &&
      changes.geographyData.previousValue !== changes.geographyData.currentValue
    ) {
      this.setGeographyValue(this.geographyData);
      if (this.otherSelected) {
        this.setOtherSelectedArray();
      }
      if (this.popularGeography && this.popularSelected) {
        this.setCheckboxAttributes();
      }
    }

    if (
      changes.otherSelected &&
      changes.otherSelected.previousValue !== changes.otherSelected.currentValue
    ) {
      this.setOtherSelectedArray();
    }
    if (
      changes.popularSelected &&
      changes.popularSelected.previousValue !==
        changes.popularSelected.currentValue
    ) {
      this.setCheckboxAttributes();
    }
    this.otherGeoExpandedKeys = [...this.otherGeoExpandedKeys];
  }

  onOtherGeoExpand(event) {
    this.otherGeoExpandedKeys = event.keys;
  }
  onAllGeographyChange(isChecked) {
    this.allGeography.partially_selected = false;
    const otherGeographyLen = this.otherGeoLen;
    if (isChecked) {
      const otherSelectedArr = [];
      this.otherGeographies.forEach((region) => {
        otherSelectedArr.push(region.key);
      });
      this.geographySelect.emit({
        regions: [this.allGeography.key],
        countries: [],
        isAllGeographySelected: isChecked,
        otherGeographyLen,
      });
      this.otherSelected.countries = new Set([]);
      this.otherSelected.regions = new Set(otherSelectedArr);
      this.setOtherSelectedArray();
    } else {
      this.otherSelected.countries = new Set([]);
      this.otherSelected.regions = new Set([]);
      this.otherSelectedArray = [];
      this.geographySelect.emit({
        regions: [],
        countries: [],
        isAllGeographySelected: isChecked,
        otherGeographyLen,
      });
    }
    this.popularGeography = {
      ...this.popularGeography,
      children: this.popularGeography.children.map((item) => ({
        ...item,
        selected: isChecked,
      })),
    };
  }

  setOtherSelectedArray() {
    if (this.otherSelected && this.otherSelected.countries) {
      this.otherSelectedArray = [...Array.from(this.otherSelected.countries)];
    }
    if (this.otherSelected && this.otherSelected.regions) {
      this.otherSelectedArray = [
        ...this.otherSelectedArray,
        ...Array.from(this.otherSelected.regions),
      ];
    }
    if (
      this.otherSelectedArray &&
      this.otherSelectedArray.length < this.otherGeoLen
    ) {
      this.allGeography.partially_selected = true;
    }
  }
  setCheckboxAttributes() {
    const _popularGeographyChildren = [];
    this.popularGeography &&
      this.popularGeography.children.forEach((countryObj) => {
        const country = { ...countryObj };
        (country as any).selected = (country.key as any).every((id) =>
          this.popularSelected.has(id),
        );
        (country as any).isInDeterminate = (country as any).partially_selected;
        // countryObj = {...country}
        _popularGeographyChildren.push(country);
      });
    this.popularGeography.children = _popularGeographyChildren;
  }
  onOtherGeographyChange(data) {
    const regions = [],
      countries = [];
    const isAllGeographySelected = false;
    data.checkedKeys.forEach((item) => {
      if (item.level === 0) {
        regions.push(item.key);
      } else {
        countries.push(item.key);
      }
    });
    const popularSeletedArray = [];
    this.popularGeography.children.forEach((popularItem) => {
      if (regions.includes((popularItem as any).region[0])) {
        popularSeletedArray.push(...popularItem.key);
      }
      (popularItem as any).country.forEach((popular_country) => {
        if (countries.includes(popular_country)) {
          popularSeletedArray.push(popular_country);
        }
      });
    });
    this.popularSelected = new Set(popularSeletedArray);

    this.otherSelected.countries = new Set(countries);
    this.otherSelected.regions = new Set(regions);
    if (
      (regions.length > 0 && regions.length < this.otherGeoLen) ||
      (regions.length === 0 && countries.length > 0)
    ) {
      this.allGeography.partially_selected = true;
      this.allGeography.selected = false;
    } else if (regions.length === 0 && countries.length === 0) {
      this.allGeography.partially_selected = false;
      this.allGeography.selected = false;
    } else if (regions.length === this.otherGeoLen) {
      this.allGeography.selected = true;
      this.allGeography.partially_selected = false;
    }
    this.setCheckboxAttributes();
    const otherGeographyLen = this.otherGeoLen;
    this.geographySelect.emit({
      regions,
      countries,
      isAllGeographySelected,
      otherGeographyLen,
    });
  }

  expandPopular(isExpanded: boolean) {
    this.isPopularExpanded = isExpanded;
  }

  checkAllGeographyStatus(selectedRegions, otherGeographies) {
    if (selectedRegions.length === 0) {
      return false;
    }
    const otherRegions = otherGeographies.map((region) => region.key);
    return otherRegions.every(
      (region) => selectedRegions.indexOf(region) !== -1,
    );
  }

  onPopularGeographyChange(isChecked, countryObj) {
    let isAllGeographySelected = false;
    this.popularGeography.children.forEach((popularGeo) => {
      if (countryObj.key === popularGeo.key) {
        popularGeo.selected = isChecked;
      }
    });
    if (isChecked) {
      // for the case when the checkbox was selected
      // First add the country id's in key to other selected countries
      // then for each parent region id, check if that region's countries are there in selected countries
      // then mark the region as selected and remove the countries from selected countries list
      countryObj.key.forEach((countryKey) =>
        this.otherSelected.countries.add(countryKey),
      );
      countryObj.region.forEach((parent) => {
        const parentRegions = this.otherGeographies.filter(
          (region) => region.key === parent,
        );
        parentRegions.forEach((region) => {
          const countryKeys = region.children.map((country) => country.key);
          if (
            countryKeys.every((countryId) =>
              this.otherSelected.countries.has(countryId),
            )
          ) {
            this.otherSelected.regions.add(region.key);
            countryKeys.forEach((countryId) =>
              this.otherSelected.countries.delete(countryId),
            );
          }
        });
      });
    } else {
      // for the case checkbox was unselected
      // First delete the country id's in key from other selected countries
      // then check if its parent regions were there in other selected regions then remove these regions
      //  from selected list and add all other countries to selected countries list.
      countryObj.key.forEach((countryKey) =>
        this.otherSelected.countries.delete(countryKey),
      );
      countryObj.region.forEach((parent) => {
        const parentRegions = this.otherGeographies.filter(
          (region) => region.key === parent,
        );
        if (this.otherSelected.regions.has(parent)) {
          this.otherSelected.regions.delete(parent);
          const countryKeys = parentRegions[0].children.map(
            (country) => country.key,
          );
          const filteredCountryKeys = countryKeys.filter(
            (cKey) => countryObj.key.indexOf(cKey) === -1,
          );
          filteredCountryKeys.forEach((key) =>
            this.otherSelected.countries.add(key),
          );
        }
      });
    }
    const regions = Array.from(this.otherSelected.regions);
    const countries = Array.from(this.otherSelected.countries);
    const otherGeographyLen = this.otherGeoLen;
    if (
      (regions.length > 0 && regions.length < this.otherGeoLen) ||
      (regions.length === 0 && countries.length > 0)
    ) {
      this.allGeography.partially_selected = true;
      this.allGeography.selected = false;
      isAllGeographySelected = false;
    } else if (regions.length === 0 && countries.length === 0) {
      this.allGeography.partially_selected = false;
      this.allGeography.selected = false;
      isAllGeographySelected = false;
    } else if (regions.length === this.otherGeoLen) {
      this.allGeography.selected = true;
      isAllGeographySelected = true;
      this.allGeography.partially_selected = false;
    }
    if (this.otherSelected && this.otherSelected.countries) {
      this.otherSelectedArray = countries;
    }
    if (this.otherSelected && this.otherSelected.regions) {
      this.otherSelectedArray = [...this.otherSelectedArray, ...regions];
    }
    this.geographySelect.emit({
      regions: regions,
      countries: countries,
      isAllGeographySelected,
      otherGeographyLen,
    });
  }

  setGeographyValue(geographies) {
    const obj = {
      allGeography: undefined,
      popularGeography: undefined,
      otherGeographies: undefined,
      otherSelected: undefined,
      popularSelected: undefined,
    };
    if (geographies && geographies.length) {
      obj.allGeography = geographies.filter((item) => item.key === -1)[0];
      // convert number type key to string because all other region and country ids will be string too
      obj.allGeography = {
        ...obj.allGeography,
        key: obj.allGeography.key.toString(),
      };
      obj.popularGeography = geographies.filter(
        (item) => item.title === "Popular",
      )[0];
      obj.otherGeographies = geographies.filter(
        (item) => item.title !== "Popular" && Number(item.key) !== -1,
      ); // Except popular and all geographies
      obj.popularGeography.children.forEach((geo) => {
        geo.country = geo.country.map((id) => (id[0] !== "C" ? `C${id}` : id));
        geo.key = geo.country;
        geo.region = geo.region.map((id) => (id[0] !== "R" ? `R${id}` : id));
      });
      obj.otherGeographies.forEach((region) => {
        region.key = `R${region.region_id.toString()}`;
        // region.selected = true;
        region.children.forEach((country) => {
          country.key = `C${country.country.toString()}`;
        });
      });
      obj.otherSelected = {
        countries: new Set(),
        regions: new Set(),
      };
      obj.popularSelected = new Set();
      if (obj.allGeography.selected) {
        // obj.otherSelected.regions.add(obj.allGeography.key);

        obj.popularGeography &&
          obj.popularGeography.children &&
          obj.popularGeography.children.forEach(
            (item) => (item.selected = true),
          );

        const regions = obj.otherGeographies.map((region) => region.key);
        obj.otherSelected.regions = new Set(regions);
        obj.popularSelected = new Set(
          obj.popularGeography.children.flatMap((country) => country.key),
        );
      } else {
        obj.popularSelected = new Set(
          obj.popularGeography &&
            obj.popularGeography.children &&
            obj.popularGeography.children
              .filter((item) => item.selected)
              .map((item) => item.key)
              .flat(),
        );

        // obj.otherSelected.countries = new Set(obj.otherGeographies && (obj.otherGeographies as any).flatMap((region) => {
        //   return region.children.filter((item) => item.selected).map((item) => item.key);
        // }));
        // obj.otherSelected.regions = new Set(obj.otherGeographies && (obj.otherGeographies as any).flatMap((region) => {
        //   return region.filter((item) => item.selected).map((item) => item.key);
        // }).flat());

        const regions = new Set();
        const countries = new Set();
        obj.otherGeographies.forEach((region) => {
          // if (region.children.every((country) => country.selected)) {
          //   regions.add(region.key);
          // }
          if (region.selected) {
            regions.add(region.key);
          } else {
            region.children.forEach((country) => {
              if (country.selected) {
                countries.add(country.key);
              }
            });
          }
        });
        obj.otherSelected.regions = regions;
        obj.otherSelected.countries = countries;
        // Sometimes UK, china and HongKong are displayed under popular category but they are not displayed under regions and countries
        // so they do not get marked as selected in otherSelected, so adding them explicitly.
        // Array.from(obj.popularSelected).forEach(countryId => obj.otherSelected.countries.add(countryId))
      }
    }
    this.allGeography = obj.allGeography;
    this.popularGeography = obj.popularGeography;
    this.otherGeographies = obj.otherGeographies;
    this.popularSelected = obj.popularSelected;
    this.otherSelected = obj.otherSelected;
  }
}
